import { css } from '@emotion/core';

export const INTENTION = css({
  padding: '0px',
});
